import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import { BsExclamationTriangle } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';
import { BILLING_SETTINGS_PATH } from '#lib/constants/routes';

const CreditsExhaustedModal = ({ isOpen, onClose, needsSubscription, limitReached = false }) => {
	const navigate = useNavigate();

	const handleSubscriptionClick = () => {
		navigate(BILLING_SETTINGS_PATH);
		onClose();
	};

	const offerSubscription = needsSubscription && !limitReached;
	let renewalText =
		'Ihre Credits sind aufgebraucht. Neue Credits stehen Ihnen zum nächsten Abrechnungszeitraum zur Verfügung.';
	if (limitReached) {
		renewalText =
			'Sie haben Ihr Monatslimit erreicht. Ein Admin Ihrer Organisation kann es unter Einstellungen › Team & Credits anheben; sonst gilt es wieder ab dem nächsten Abrechnungszeitraum.';
	} else if (needsSubscription) {
		renewalText =
			'Ihre Credits sind aufgebraucht. Um weiterhin alle Features nutzen zu können, wählen Sie bitte ein passendes Abonnement aus.';
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="m">
			<Panel.Header icon={BsExclamationTriangle} onClose={onClose}>
				{limitReached ? 'Monatslimit erreicht' : 'Credits aufgebraucht'}
			</Panel.Header>
			<Panel.Body>
				<p className="text-sm text-text">{renewalText}</p>
			</Panel.Body>
			<Panel.Footer className="justify-end">
				{offerSubscription ? (
					<>
						<Button variant="outline" onClick={onClose}>
							Später
						</Button>

						<Button variant="solid" onClick={handleSubscriptionClick}>
							Abonnement auswählen
						</Button>
					</>
				) : (
					<Button variant="outline" onClick={onClose}>
						Verstanden
					</Button>
				)}
			</Panel.Footer>
		</Modal>
	);
};

CreditsExhaustedModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	needsSubscription: PropTypes.bool.isRequired,
	limitReached: PropTypes.bool,
};

export default CreditsExhaustedModal;
